module.exports = __webpack_public_path__ + "img/beatout-team.40c0538b.svg";